import {HTTP} from '@/CallAPI'
export default {
  getNotification (page) {
    return HTTP.get('notifications', {
      params: {
        page
      }
    })
  },
  readAllNotification () {
    return HTTP.post('notifications')
  },
  readNotification (notification) {
    return HTTP.put('notifications/' + notification.id)
  },
  getUnreadNotification () {
    return HTTP.get('notifications?unread=')
  }
}



// WEBPACK FOOTER //
// ./src/service/notification.js